import React, { Fragment, useState } from "react";
import { useSelector } from "react-redux";
import api from "../../../../api";
import { useLog, Log } from "../../../../core";
import { State } from "../../../../core/store/interfaces";
import LogItem from "./log-item";
import { ContainerLoader } from "../../../../components/loader";
import ListFilter from "./ListFilter";
import { DocumentCopyType } from '../../../agreement/Invoice/components/List';

interface ILogProps {
  leadId?: string;
  customerId?: string;
  ocrDocumentId?: string;
  companyId?: string;
  genericProposalDocumentId?: string;
  stageCode?: string;
  documentCopyType?: DocumentCopyType;
}

interface Filters {
  eventType?: string;
  userId?: string;
  fromDate?: string;
  toDate?: string;
  leadId?: string;
  customerId?: string;
  includeAllCustomerLogs?: boolean;
  ocrDocumentId?: string;
  companyId?: string;
  stageCode?: string;
  genericProposalDocumentId?: string;
  documentCopyType?: DocumentCopyType;
}

const UserLogs: React.FunctionComponent<ILogProps> = (props) => {
  const { loadAllLog } = useLog(api.log);
  const logState = useSelector((state: State) => state.log);
  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [filters, setFilters] = useState<Filters>({});
  const [page, setPage] = useState(1);

  const setNewFilters = (nw: Filters) => {
    setFilters(nw);
  };

  React.useEffect(() => {
    const selectedFilters = { ...filters, page: page || 1 };
    if (props?.ocrDocumentId) {
      selectedFilters.ocrDocumentId = props.ocrDocumentId;
      // selectedFilters.includeAllCustomerLogs = true;
    }
    if (props.leadId) {
      selectedFilters.leadId = props.leadId;
      selectedFilters.includeAllCustomerLogs = true;
    }
    if (props.customerId) {
      selectedFilters.customerId = props.customerId;
    }
    if (props.companyId) {
      selectedFilters.companyId = props.companyId;
    }
    if (props.stageCode) {
      selectedFilters.stageCode = props.stageCode;
    }
    if (props.genericProposalDocumentId) {
      selectedFilters.genericProposalDocumentId = props.genericProposalDocumentId;
    }
    if (props.documentCopyType) {
      selectedFilters.documentCopyType = props.documentCopyType;
    }
    loadAllLog(selectedFilters, () => {
      setIsLoaded(true);
    });
  }, [filters, page, props.genericProposalDocumentId]);

  return (
    <Fragment>
      {logState.data?.count === 0 && !logState.isLoading && (
        <li className="text-center mb-4 pb-2 mb-3 position-relative zIndex-1">
          <span className="px-2 font-sm text-uppercase">No Logs</span>
        </li>
      )}

      <>
        <div className="d-flex align-items-center mb-3">
          <div className="col d-flex"></div>
          <div className="col-auto">
            <div
              className="d-inline-flex align-items-center font-xs text-primary font-weight-semibold cursor-pointer"
              onClick={() => setIsOpenFilter(true)}
            >
              <i className="icon-filter font-sm mr-2"></i>Filter
            </div>
          </div>
        </div>

        {isOpenFilter && (
          <ListFilter
            onFilter={setNewFilters}
            hideFilter={() => setIsOpenFilter(false)}
            hideCRMFilter={props?.ocrDocumentId ? true : false}
          ></ListFilter>
        )}
      </>

      <div className="">
        {logState?.data?.data?.map((p: Log, index: number) => {
          return (
            <div key={"log-" + index}>
              <LogItem log={p} customerId={props.customerId}></LogItem>
            </div>
          );
        })}
        {!logState.isLoading &&
          (logState?.data?.data?.length ?? 0) < (logState?.data?.count ?? 0) &&
          (logState?.data?.data?.length ?? 0) !== 0 && (
            <div className="text-center">
              <span
                onClick={() => {
                  setPage?.((logState?.data?.page ?? 0) + 1);
                }}
                className="rounded-pill px-2 font-xxs text-uppercase cursor-pointer"
              >
                Load more
              </span>
            </div>
          )}
        {logState.isLoading && <ContainerLoader></ContainerLoader>}
      </div>
    </Fragment>
  );
};

export default UserLogs;
